import React from 'react';
import {List, ListItem} from 'material-ui/List';
import ContentInbox from 'material-ui/svg-icons/content/inbox';
import ActionGrade from 'material-ui/svg-icons/action/grade';
import ContentSend from 'material-ui/svg-icons/content/send';
import ContentDrafts from 'material-ui/svg-icons/content/drafts';
import Divider from 'material-ui/Divider';
import ActionInfo from 'material-ui/svg-icons/action/info';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

const BiochemistryMenu = () => (

  <MuiThemeProvider>
    <List style = {{padding: 0}}>
    <Link style = {{color: 'black'}} to = "/"> <ListItem>Amino Acids </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/SIUnits">  <ListItem> SI Units </ListItem> </Link>
      <Divider />
      <ListItem> More coming soon </ListItem>
      <Divider />

    </List>

  </MuiThemeProvider>
);

export default BiochemistryMenu;



// WEBPACK FOOTER //
// ./src/Biochemistry/BiochemistryMenu.js